import { Deferred } from './DeferredPromise';

export class QueuedPromiseRequests {
  public static async queue<T>(functionWrapper: () => Promise<T>, lockKey: string): Promise<T> {
    const activeLock = this.activeLocks.get(lockKey);
    const deferred = activeLock || new Deferred();
    try {
      if (activeLock) {
        return activeLock.promise;
      }
      this.activeLocks.set(lockKey, deferred);
      const result = await functionWrapper();
      deferred.resolve(result);
      this.activeLocks.delete(lockKey);
      return result;
    } catch (e: any) {
      deferred.reject(e);
      this.activeLocks.delete(lockKey);
      throw e;
    }
  }

  private static activeLocks = new Map<string, Deferred>();
}
